import Vue from 'vue'
import Cookies from 'js-cookie'
import ElementUI from 'element-ui';
import './styles/element-variables.scss'
import '@/styles/index.scss' // global css

import App from './App.vue'
import router from './router'
import store from './store'
window._axiosPromiseArr = []
import './icons' // icon
import './permission' // permission control
import _ from 'lodash'
Vue.prototype._ = _
Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')